import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import App from './App.jsx'
import { pruneExpiredCaches, enforceFreshBuildCache } from './utils/cache.js'
import { installFrontendLogger } from './utils/frontendLogger.js'

const BUILD_ID_FALLBACK =
  typeof globalThis !== 'undefined' && typeof globalThis.__APP_BUILD_ID__ !== 'undefined'
    ? globalThis.__APP_BUILD_ID__
    : ''

const BUILD_ID =
  import.meta.env.VITE_APP_BUILD_ID ||
  import.meta.env.VITE_APP_VERSION ||
  import.meta.env.VITE_COMMIT_SHA ||
  import.meta.env.VITE_BUILD_TIMESTAMP ||
  BUILD_ID_FALLBACK;

enforceFreshBuildCache(BUILD_ID)
pruneExpiredCaches()
installFrontendLogger()

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>
)
